const e = `<svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
        <g>
            <circle stroke="#DDD" stroke-width=".8" cx="16" cy="16" r="15.6" />
            <path
                d="M21.333 14.619a5.16 5.16 0 01-3.045-.989v4.5c-.001 1.707-1.045 3.235-2.62 3.833a3.993 3.993 0 01-4.455-1.146 4.141 4.141 0 01-.505-4.636 4.016 4.016 0 014.1-2.106v2.263a1.836 1.836 0 00-2.06.699c-.466.66-.46 1.55.013 2.205a1.836 1.836 0 002.068.674 1.877 1.877 0 001.275-1.785V9.333h2.184c-.002.187.014.374.046.559a3.078 3.078 0 001.337 2.02 2.98 2.98 0 001.662.507v2.2z"
                fill="#010101" fill-rule="nonzero" />
        </g>
    </g>
</svg>`;
export {
  e as default
};
//# sourceMappingURL=tiktok-color.es.R6lRHjwq.js.map
